import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {UserService} from '../../../../services/user.service';

enum Routes {
  info,
  settings,
  orders,
  invoices,
  discounts,
  carriers,
  notes,
}

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

export class UserComponent implements OnInit, OnDestroy {
  routeState: number;
  routerParamsSubscription: Subscription;
  userId: string;
  userDetails: any;
  routes = Routes;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.firstChild) {
      this.routeState = this.routes[this.activatedRoute.snapshot.firstChild.routeConfig.path];
    } else {
      this.routeState = 0;
    }
    this.routerParamsSubscription = this.route.params.subscribe(params => {
      this.userId = params['id']; // (+) converts string 'id' to a number
      this.userService.getUser(this.userId);
      // In a real app: dispatch action to load the details here.
    });
  }

  handleRedirect(event) {
    this.routeState = event.index;
    this.router.navigate(['/admin', 'users', this.userId, this.routes[event.index]]);
  }

  ngOnDestroy() {
    this.routerParamsSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/user/user.component.ts